import { render, staticRenderFns } from "./Pentagon.vue?vue&type=template&id=66e6a6b3&scoped=true&"
import script from "./Pentagon.vue?vue&type=script&lang=js&"
export * from "./Pentagon.vue?vue&type=script&lang=js&"
import style0 from "./Pentagon.vue?vue&type=style&index=0&id=66e6a6b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e6a6b3",
  null
  
)

export default component.exports